import instance from "@/utils/require.js"

// 坏件登记--配件类型枚举
export function apiPartTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/part_type",
		method: "post",
		data
	})
}

// 坏件登记--登记坏件
export function apiRegisterDefective(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc_part/register_defective",
		method: "post",
		data
	})
}

// 坏件登记--查询坏件列表
export function apiSearchDefective(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc_part/search_defective",
		method: "post",
		data
	})
}
